import { i18nClient } from '@sailor/i18n-web'
import { downloadFile } from './download'
import { failToast } from './toast'

export interface PollingParams {
  /** * 轮询请求 */
  requestFunction: () => Promise<any>;
  /**
   * 成功回调
   */
  onSuccess: (data: any) => void;
  /**
   * 成功态判断
   */
  checkSuccess: (data: any) => boolean;
  /**
   * 异常回调
   */
  onError?: (error: any) => void;
  /** * 失败态判断 */
  checkError?: (error: any) => boolean;

  /** * 请求间隔，兜底 600ms */
  timeout?: number;
  disablePollingRef?: { current: boolean }
  onTimeoutChange?: (timeout: number) => void
}

const MAX_FETCH_COUNT = 100

export const createPolling = ({
  requestFunction,
  timeout = 600,
  onSuccess,
  checkSuccess,
  onError,
  checkError,
  onTimeoutChange,
}: PollingParams): void => {
  async function fetchData (preFetchedCount:number) {
    try {
      const res = await requestFunction()
      if (checkSuccess(res)) {
        onSuccess(res)
      } else if (checkError?.(res)) {
        throw res
      } else if (preFetchedCount > MAX_FETCH_COUNT) {
        throw { message: i18nClient.getText('e_pc_require_overtime', '查询结果超时,请重试') }
      } else {
        const timeoutRef = setTimeout(() => {
          fetchData(preFetchedCount + 1)
        }, timeout)
        if (onTimeoutChange) {
          onTimeoutChange(timeoutRef as unknown as number)
        }
      }
    } catch (error) {
      onError?.(error)
    }
  }
  fetchData(0)
}


export interface IExcelDataRes {
  /** 代码 10-处理开始，20-处理中，30-处理完成，40-处理失败 */
  code?: 10 | 20 | 30 | 40;
  /** 信息 */
  message: string;
  /** 上传信息失败条数 */
  errorCount?: number;
  /** 下载链接 */
  fileUrl?: string;
  /** 失败的费用Excel */
  failFileUrl?: string;
  /** 上传信息成功条数 */
  successCount?: number;
  fileS3Name?: string;
  fileName?: string
}
interface IExcelPollingParams extends  Pick<PollingParams, 'requestFunction' | 'onTimeoutChange'> {
  needDownload?: boolean,
  onFinish: (param: { type: 'success' | 'fail', data: IExcelDataRes }) => void
}
export function excelPolling (param:  IExcelPollingParams) {
  const { needDownload, onFinish, ...originParam } = param
  createPolling({
    ...originParam,
    timeout: 2000,
    checkSuccess: (data:IExcelDataRes) => data.code === 30,
    onSuccess: (data:IExcelDataRes) => {
      const { fileUrl } = data || {}
      const regex = /\/([^?#]+\.(xlsx|xls))(?:\?|#|$)/i
      // 使用正则表达式匹配
      const match = fileUrl?.match(regex) || []
      if (needDownload) {
        const fileName = match[1] || ''
        downloadFile({
          url: fileUrl,
          fileName,
        })
      }
      onFinish({ type: 'success', data })
    },
    checkError: (data: IExcelDataRes) =>  data?.code === 40,
    onError: (error: IExcelDataRes) => {
      if (error.code === 40) {failToast(error.message)}
      onFinish({ type: 'fail', data: error })
    },
  })
}

